var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFileAttachmentDucUploadFile = function SvgFileAttachmentDucUploadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.03 14.278H.997v-.951H17.03v.951ZM9.415.49a.48.48 0 0 0-.483.475v9.863a.48.48 0 0 0 .483.475.48.48 0 0 0 .483-.475V.965a.48.48 0 0 0-.483-.476Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08.622a.494.494 0 0 0 0 .686l3.207 3.288c.185.189.485.189.67 0a.494.494 0 0 0 0-.687L9.75.622a.465.465 0 0 0-.67 0Z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75.622a.465.465 0 0 0-.67 0L5.874 3.909a.494.494 0 0 0 0 .687c.185.189.484.189.67 0L9.75 1.308a.494.494 0 0 0 0-.686ZM17.43 8.871a.48.48 0 0 1 .484.476v4.931h-.967V9.348a.48.48 0 0 1 .484-.476ZM1.398 8.871a.48.48 0 0 1 .483.476v4.931H.914V9.348a.48.48 0 0 1 .484-.476Z",
    fill: "#484848"
  })));
};
export default SvgFileAttachmentDucUploadFile;